import { useEffect, useState } from "react";
import { retrievePayerTypes } from "../../../../lib/systemData";
import CustomSelect from "../../../common/interactive/CustomSelect";
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple";
import Button from "../../../common/Button";

export default function PayerTypeStatusRepeaterOption({classes, filterItem, mainSelectAction, filtersValues, itemIndex, workQ, itemData, hasRemove}) {

    const [payerTypesOptions, setPayerTypesOptions] = useState(retrievePayerTypes())
    // const [rebuildEnabled, setRebuildEnabled] = useState(false)
    const [payerStatusOptions, setPayerStatusOptions] = useState([{
        label: 'placeholder',
        value: 'placeholder'
    }])

    // const [selectedpayerStatus, setSelectedpayerStatus] = useState()

    const [payerStatusDisabled, setPayerStatusDisabled] = useState(true)
    const [rebuildStatusComponent,setRebuildStatusCompoent] = useState(1)

    function payersStatusOptionRigidFilter(payerTypeID, groupOptions) {
        // first check filters, if nothing go next block 
        if (workQ && workQ.filter_conditions) { 
            if (workQ.filter_conditions[`${itemData.key}_filter_type`] && workQ.filter_conditions[`${itemData.key}_filter_type`] == 1) {   // rigid filters are marked as 1 !!   
                // in a rigid  filter need to filter the options from the system
                let selectedOption = workQ.filter_conditions[itemData.key].find(item => item.payer_type_id == payerTypeID) 
      
                let allpayerStatusFromID = retrievePayerTypes().find(item => item.value == payerTypeID) // get whole the selected rigid filter from the payer_type_id
          
                if (selectedOption) {
                    let statusoptions = selectedOption.payer_status_id
                    if (statusoptions && statusoptions.length) {  
                        let newStatusOptions = []
                        statusoptions.forEach(item => {
                            let found = allpayerStatusFromID.payer_statuses.find(elem => elem.id == item)
                      
                            if (found) {
                                newStatusOptions.push(found)
                            }
                        })
                       
                        if (newStatusOptions && newStatusOptions.length) { // we have at least one status from rigid filtering
                  
                            setPayerStatusOptions(newStatusOptions.map(item => {
                                return {
                                    label: item.name,
                                    value: item.id
                                }
                            }))

                            setPayerStatusDisabled(false)
                            setRebuildStatusCompoent(value => value + 1)

                            return null
                        } else {
                            // setPayerStatusOptions(allpayerStatusFromID.payer_statuses.map(item => {
                            //     return {
                            //         label: item.name,
                            //         value: item.id
                            //     }
                            // }))

                            // no options found 
                            setPayerStatusOptions([{
                                label: 'placeholder',
                                value: 'placeholder'
                            }])
                            setPayerStatusDisabled(true)
                            setRebuildStatusCompoent(value => value + 1)

                            return null
                        }
                        
                        
                    }
                }
            }
        } 

        // there is no rigid filtering
        if (groupOptions && groupOptions.payer_statuses) {       
   
            setPayerStatusOptions(groupOptions.payer_statuses.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            })) 
            setPayerStatusDisabled(false)
            setRebuildStatusCompoent(value => value + 1)
        
        } else {
            setPayerStatusOptions([{
                label: 'placeholder',
                value: 'placeholder'
            }])
            setPayerStatusDisabled(true)
            setRebuildStatusCompoent(value => value + 1)
            
        }
    }

    function onPayerTypeChange(value) {   
        if (value.option && value.option.payer_statuses ) {

            setPayerStatusOptions(value.option.payer_statuses.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            }))
            setPayerStatusDisabled(false)
            setRebuildStatusCompoent(value => value + 1)
        }        

        if (mainSelectAction) {
            mainSelectAction(value, filtersValues)
        }  
     
    }

    function removeRepeaterItemHandler() {

        if (onPayerTypeChange) {
            onPayerTypeChange({
                data: {
                    value: null
                },
                identifier: {type: 'payer_type', index: itemIndex},
                isRemove: true
            })
        }
    }

    useEffect(() => {

        // rigid filter for payer types 
        if (workQ && workQ.filter_conditions) {  // nned to see if there is a rigid filter and set the option for the payer type here 
            if (workQ.filter_conditions[`${itemData.key}_filter_type`] && workQ.filter_conditions[`${itemData.key}_filter_type`] == 1) {         
                // in a rigid  filter need to filter the options from the system                

                let payerTypesSelected = []
                workQ.filter_conditions[itemData.key].forEach(item => {
                    payerTypesSelected.push(Number(item.payer_type_id))
                })      

                if (payerTypesSelected) {
                    setPayerTypesOptions(retrievePayerTypes().filter(item => payerTypesSelected.includes(item.value)))
                }
                
            }
        } 


        let groupOptions = retrievePayerTypes().find(item => item.value == filterItem?.payer_type_id)
        payersStatusOptionRigidFilter(filterItem?.payer_type_id, groupOptions)

    }, [filterItem])   //filterItem?.payer_type_id

    return <>
        <div className={classes.row}>
            <CustomSelect preSelectedValue={filterItem?.payer_type_id} optionsData={payerTypesOptions} label={'Payer Type'} identifier={{type: 'payer_type', index: itemIndex}} action={onPayerTypeChange} ignoreDeactivatedOptions={true}  hasRemove={true}/> 
        </div>
        <div className={classes.row}>
            {<CustomSelectMultiple rebuild={rebuildStatusComponent} hasRebuildEnabled={false} preSelectedValue={filterItem?.payer_status_id} identifier={{type: 'payer_status', index: itemIndex}} optionsData={payerStatusOptions} label={'Payer Status'}  action={mainSelectAction} isDisabled={payerStatusDisabled} />}           
        </div>
        {hasRemove && <div className={classes.remove_button}><Button click={removeRepeaterItemHandler}><i className="ti ti-minus"></i></Button></div>}
    </>
}